import { BaseService } from '../../infra/base.service'
import type { Referral } from './referral'
import type { ReferralsRepository } from './referrals.repository'

export class ReferralsService extends BaseService<Referral> {
    constructor(private rep: ReferralsRepository) {
        super(rep)
    }

    async report(from: Date, to: Date) {
        return await this.rep.report(from, to)
    }
}
